export default __webpack_public_path__ + "static/media/home.6ea17580.svg";